











































































































import { Component, Vue } from 'vue-property-decorator';
import { DATA } from '@/config/data';
import authService from '@/services/auth-services';
import { Customer } from '@/models/customer';
import Loading from 'vue-loading-overlay';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';


@Component({
    components: {
        Loading,
    },
})
export default class Register extends Vue {
    private isLoading = false;
    private firstName = '';
    private lastName = '';
    private phoneNumber = '';
    private email = '';
    private userName = '';
    private address = '';
    private password = '';
    private rePassword = '';
    private selectedStoreArea = 1;
    private selectedChinaStore = 1;
    private selectedService = this.isDepositSystem ? 2 : 1;
    private isAcceptPolicy = 0;

    constructor() {
        super();
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    get serviceTypes() {
        return DATA.serviceTypes;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
    }

    private async submit() {
        const isValid = await (this.$refs['observer'] as any).validate();

        if (isValid) {
            if(!this.isAcceptPolicy) {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Vui lòng xác nhận chính sách và đồng ý với quy định vận chuyển.',
                });
                return;
            }
            this.isLoading = true;
            const dataRequest: Customer = {
                UserName: this.userName.toLowerCase(),
                Email: this.email,
                FirstName: this.firstName,
                LastName: this.lastName,
                PhoneNumber: this.phoneNumber,
                Password: this.password,
                ReceivePlaceID: this.selectedStoreArea,
                ChinaStoreID: this.selectedChinaStore,
                ServiceType: this.selectedService,
                Address: this.address
            };
            const result  = await authService.register(dataRequest);
            this.isLoading = false;
            if (result && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Bạn đã đăng ký thành công!',
                });
                (window['getApp'] as any).$emit('APP_REGISTER_SUCCESS');
            } else if (result && result.data.status === 202 && result.data.error === 'Tài khoản đã tồn tại.') {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Tài khoản, số điện thoại hoặc email đã tồn tại!',
                });
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Có lỗi trong quá trình xử lý dữ liệu!',
                });
            }
        }
    }
}
